import React from "react";
import { Link } from "react-router-dom";
import { ProductCard } from "../ProductCard";

export const FeaturedDropsSection = ({ products }) => (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="flex items-end justify-between mb-8 border-b-2 border-black pb-3">
            <h2 className="font-display text-3xl md:text-5xl font-black uppercase tracking-tight">
                Picked Across Stores
            </h2>
            <Link
                to="/search"
                data-testid="view-all-link"
                className="font-mono text-xs uppercase tracking-widest underline underline-offset-4"
            >
                Search all →
            </Link>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 md:gap-6">
            {(products || []).map((p) => (
                <ProductCard key={p.id} product={p} />
            ))}
        </div>
    </section>
);
